import React, { useState, useCallback, useEffect } from "react";
import SearchGarageList from "./components/garage_list/SearchGarageList";
import { Link } from "react-router-dom";
import Map from "./components/map/map";
import { getDirectionFromPoint } from "./services/mapbox/mapboxServices";
import { useSelector } from "react-redux";
import { useGeolocated } from "react-geolocated";
import axios from "axios";
import * as turf from '@turf/turf';
import { format } from 'date-fns';
import Metatags from "../Metatags/Metatags";
function Landing() {
	const [myplace, setPlaces] = useState(null);
	const [listGarages, setListGarages] = useState(null);
	const [currentLocation, setCurrentLocation] = useState(null);
	const [garagesLocations, setGaragesLocations] = useState(null);

	const [circle, setCircle] = useState(null);
	const [radiusmy, setRadius] = useState(5);
	const user = useSelector(state => state.user.uid);
	const showTime = format(new Date(), 'MMddyyyyHis');

	const bringGaragesLoactions = useCallback(async (coors) => {

		var center = [coors.lng, coors.lat];
		var radius = radiusmy;
		var options = { steps: 10, units: 'kilometers' };
		var turff = turf.circle(center, radius, options);
		setCircle(turff)

		try {
			const place = await getDirectionFromPoint(coors);
			const formData = new FormData();
			formData.append('action', 'AutoSearchGarage');
			formData.append('lat', coors.lat);
			formData.append('lon', coors.lng);
			formData.append('radius', radiusmy);

			setPlaces(place)

			const responseZipCode = await axios.post(`${process.env.REACT_APP_API_URL}`, formData);
			setListGarages(() => ({ ...responseZipCode.data.data }));


			const garagesLocations = responseZipCode.data.data;
			let garagesLocationsObject = {}
			garagesLocations.forEach(item => {
				if (item) {
					garagesLocationsObject = {
						...garagesLocationsObject,
						[item.id]: {
							PageLink: item.id,
							coordinates: { 'latitude': item.lat, 'longitude': item.lon },
							address: `${(user !== "none" && user !== "") ? item.address : ''}`,
							secondLine: `${'<b>Area</b> : ' + item.area + ', DOOR TYPE : '
								+ (item.isConnectedToHouse ? 'Connected to the House | ' : '')
								+ (item.doorOpener ? 'Door Opener | ' : '')
								+ (item.drywalled ? 'Drywalled | ' : '')
								+ (item.otherStorage ? 'Other Storage | ' : '')
								+ (item.sideDoor ? 'Side Door | ' : '')
								+ (item.windows ? 'Windows' : '')
								}`,
							imageUrl: process.env.REACT_APP_UPLOAD_URL + item.garagePictures[0] + '?time=' + showTime,
							rotateA: item.garagePicturesA[0] ? item.garagePicturesA[0] : ''

						}
					};
				}
			})
			return garagesLocationsObject;


			// return response.data.data
			// 	})
			// 	.catch(error => {
			// 		console.log(error)
			// 	});
			// return null;
		} catch (err) {
			throw err;
		}
	}, []);


	useEffect(() => {
		// console.log('currentmyplace', myplace)
		localStorage.setItem('fetchAd', JSON.stringify(myplace));
	}, [myplace]);


	const actionForMap = useCallback(async newLgLt => {
		try {
			const place = await getDirectionFromPoint(newLgLt);
			//console.log('place',place)
			let arrayForFiltering = [];
			const formData = new FormData();
			formData.append('action', 'SearchGarage');

			if (place.zipCode !== '') arrayForFiltering = [...arrayForFiltering, [
				formData.append('zipCode', place.zipCode)
			]];
			if (place.city !== '') arrayForFiltering = [...arrayForFiltering, [
				formData.append('city', place.city)
			]];
			if (place.state !== '') arrayForFiltering = [...arrayForFiltering, [
				formData.append('state', place.state)
			]];
			if (place.neighborhood !== '') arrayForFiltering = [...arrayForFiltering, [
				formData.append('neighborhood', place.neighborhood)
			]];


			localStorage.setItem('fetchAd', JSON.stringify(place));

			const responseZipCode = await axios.post(`${process.env.REACT_APP_API_URL}`, formData)
				.then(response => {
					setListGarages(() => ({ ...response.data.data }));
				})
				.catch(error => {
					setListGarages(() => null);
				});
		} catch (err) {
			throw err;
		}
	}, []);

	const props = useGeolocated({
		positionOptions: {
			enableHighAccuracy: false
		},
		userDecisionTimeout: 5000
	})

	useEffect(() => {
		if (props.coords) {

			// console.log('props.coords', props.coords);
			bringGaragesLoactions({
				lng: props.coords.longitude,
				lat: props.coords.latitude
			}).then(resp => {
				//  console.log('useeffect resp', resp);
				setGaragesLocations(() => resp);
			});

			setCurrentLocation(() => ({
				longitude: props.coords.longitude,
				latitude: props.coords.latitude
			}));
		} else {
			//	actionForMap({ lng: defaultLongitude, lat: defaultLatitude });
		}
	}, [props.coords, bringGaragesLoactions]);

	return (
		<>
		 <Metatags 
        title="Find Parking Spaces | GarageXY"
        description="Affordable hourly and daily parking solutions near you"
        keywords="parking near me, garage rental, cheap parking, monthly parking"
      />
			{/* <Metatags
				title="Garage Storage Here"
				description="Store your stuff in a garage"
				keywords="Extra Space Storage, Storage, storage near me, Garage, neighbor, public storage, storefoot, pods"
			/> */}
			<section className="main-banner-sec hero">
				<div className="container-full">
					<div className="row">
						<div className="col-md-6 banner-details text-center  d-flex flex-column justify-content-around">
							<h1 className="text-center text-white">
								Find STORAGE or PARKING <br /><span>affordable spaces near you</span>
							</h1>
							<div className="row px-2">
								<div className="col-lg-6">
									<Link to="/search" className="col-sm-12 py-3 text-primary btn btn-light btn-lg my-3 border2 border-primary">
										FIND A GARAGE
									</Link>
								</div>
								<div className="col-lg-6">
									<Link
										to={user !== "none" ? "/garages" : "/sign_up"}
										className="col-sm-12 py-3 btn btn-primary btn-lg my-3"
									>
										RENT YOUR GARAGE
									</Link>
								</div>
							</div>
						</div>
						<div className="col-md-6 py-2 px-4" style={{ height: '500px' }}>
							<Map
								type="multiple_pointers"
								action={actionForMap}
								actionLabel="done"
								geoLocation={currentLocation}
								garagesOnMap={garagesLocations}
								extraInfo={JSON.stringify(circle)}
								addClass="homepage-map"
							/>
						</div>
					</div>
					{/* <div className="banner-details text-centerbanner-details text-center">
                    <h2>Find your future home</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    
                    
                </div> */}
				</div>
			</section>


			<section className="sale-items-sec sec-padding">
				<div className="container-fluid">
					<div className="sec-title text-center">
						<h3>LATEST FOR RENT</h3>
					</div>
					<div className="sales-items">
						<div >
							<SearchGarageList garagesList={listGarages}
								column={4} />

							{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                            <div className="sale-item">
                                <div className="item-img over_lay">
                                    <a href="11_Single_Properties_Standart.html" title="" className="ext-link">
                                        <img src="assets/images/resources/img4.jpg" alt=""/>
                                    </a>
                                    <span className="item-status">For Sale</span>
                                </div>
                                <div className="item-info">
                                    <h3><a href="11_Single_Properties_Standart.html" title="">Dramatic and Unique Condo</a></h3>
                                    <span>Reno Pl, San Francisco, CA 94133</span>
                                    <div className="specs-info">
                                        <ul>
                                            <li>Beds: 4 </li>
                                            <li>Baths: 2 </li>
                                            <li>Sqft: 1,570</li>
                                        </ul>
                                        <strong className="item-price">$499,500</strong>
                                    </div>
                                </div>
                            </div>
                        </div> */}

						</div>
					</div>
				</div>
			</section>
		</>
	)
}
export default Landing;